import styles from "./BundleEmbed.module.css";
import { Button, ButtonGroup, Icon, TextField, Tooltip } from "@shopify/polaris";
import { ClipboardIcon, InfoIcon } from "@shopify/polaris-icons";
import useBundleMixpanelHook from "../../hooks/useBundleMixpanelHook";
import { BundleTypes } from "../../apps/Bundles/constants";
import { useState } from "react";

const BundleEmbed = ({ bundle_embed_id, bundleType }: { bundleType: string; bundle_embed_id: any }) => {
    const { trackEmbedCodeCopy } = useBundleMixpanelHook();
    const [activeButtonIndex, setActiveButtonIndex] = useState(0);
    const handleButtonClick = (index: number) => {
        setActiveButtonIndex(index);
    };

    const value =
        bundleType === BundleTypes.BUNDLE_BUILDER
            ? `<div data-kefi-bundle-id="${bundle_embed_id.value}" bundle-builder-type="${
                  activeButtonIndex === 0 ? "cta" : "bundle"
              }" ></div>`
            : `<div data-kefi-bundle-id="${bundle_embed_id.value}"></div>`;

    const handleCopyText = (text: string) => {
        navigator.clipboard.writeText(text);
        shopify.toast.show("Embed Code copied");
        trackEmbedCodeCopy({
            cta: "Embed Code Copied",
            ctaType: "Copy",
            bundleType: bundleType || "",
        });
    };

    console._log(bundle_embed_id);

    return (
        <div className={styles.mainContainer}>
            {/* <h2 className={styles.heading}>Embed this bundle anywhere</h2> */}

            <TextField
                label={
                    <>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                color: "#303030",
                            }}
                        >
                            Embed this bundle manually in any page via HTML
                            <div>
                                <Tooltip
                                    width="wide"
                                    content={
                                        "Display this bundle anywhere by placing this HTML Tag in your theme file."
                                    }
                                >
                                    <Icon source={InfoIcon} tone="subdued" />
                                </Tooltip>
                            </div>
                        </div>
                        {bundleType === BundleTypes.BUNDLE_BUILDER && (
                            <div style={{ marginTop: "8px", marginBottom: "8px" }}>
                                <ButtonGroup variant="segmented">
                                    <Button pressed={activeButtonIndex === 0} onClick={() => handleButtonClick(0)}>
                                        Upsell Button
                                    </Button>
                                    <Button pressed={activeButtonIndex === 1} onClick={() => handleButtonClick(1)}>
                                        &nbsp;&nbsp;&nbsp;&nbsp;Bundle&nbsp;&nbsp;&nbsp;&nbsp;
                                    </Button>
                                </ButtonGroup>
                            </div>
                        )}
                    </>
                }
                // label={"Display this bundle anywhere by placing this HTML Tag in your theme file."}
                placeholder="<div data-kefi-bundle-id=''></div>"
                autoComplete={"off"}
                value={value}
                readOnly
                connectedRight={
                    <div style={{ marginLeft: "8px" }}>
                        <Button
                            onClick={() => handleCopyText(value)}
                            size="slim"
                            icon={<Icon source={ClipboardIcon} />}
                        >
                            Copy
                        </Button>
                    </div>
                }
            />

            {/* <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    marginTop: "-2px",
                }}
            >
                <RadioButton
                    label={"Show bundle on any page"}
                    checked={!!render_embed_on_visibility.value == false}
                    name="embed_visibility"
                    onChange={() => {
                        dispatchBundleConfig({
                            payload: false,
                            key: "render_embed_on_visibility",
                        });

                        render_embed_on_visibility.onChange(false);
                    }}
                />
                <RadioButton
                    label={"Show bundle according to visibility"}
                    name="embed_visibility"
                    checked={!!render_embed_on_visibility.value == true}
                    onChange={() => {
                        dispatchBundleConfig({
                            payload: true,
                            key: "render_embed_on_visibility",
                        });

                        render_embed_on_visibility.onChange(true);
                    }}
                />
            </div> */}

            {/* <p className={styles.bundleId}>Bundle ID: {bundle_embed_id.value}</p> */}
        </div>
    );
};

export default BundleEmbed;
